export default "__VITE_ASSET__5971cc58__"